import React, { useState } from 'react';
import { Alert } from 'react-bootstrap';
import { useHistory } from 'react-router';
import BackIcon from '@material-ui/icons/ArrowBack'


const API_URL = 'https://stanley5.com:9501'
// const API_URL = 'http://localhost:9501'

export function CreatePage() {
  const [show, setShow] = useState<boolean>(false);
  const [name, setName] = useState<string>('');
  const [error, setError] = useState<string>(' ');
  const history = useHistory();

  async function handleSubmit(event: any) {
    event.preventDefault();
    if (name.length === 0) {
      setError('Please enter a name for your timer.');
      return;
    }
    fetch(API_URL + '/create-session', {
      method: 'POST',
      body: new URLSearchParams({
        name: name
      })
    })
      .then(async (res) => await res.json())
      .then((data) => {
        history.push(`/stopwatch/${data.created}`);
      })
      .catch((err) => {
        console.log(err);
        setError("Couldn't create the session.");
      })
  }


  function instructions() {
    if (show) {
      const text: string = "Enter a name for your stopwatch and click 'connect' to start.";
      return (
        <Alert variant="warning" className="instructions" style={{
          position: "absolute",
          marginRight: "auto",
          marginLeft: "auto",
          marginTop: "10px",
          zIndex: 1,
          left: "0",
          right: "0",
          top: "0",
        }} onClose={() => setShow(false)} dismissible>
          <Alert.Heading style={{ textAlign: 'center' }}>How to Share</Alert.Heading>
          <p style={{ textAlign: 'center' }}>{text}</p>
        </Alert>
      )
    }
  }


  return (
    <div>
      {instructions()}
      <button onClick={() => history.push('/')} style={{ position: 'absolute', top: '.75rem', left: '.75rem', backgroundColor: '#c96363', fontSize: '1.5em', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '999px' }}><BackIcon fontSize='inherit' /></button>
      <form style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} onSubmit={handleSubmit}>
        <label>Session Name</label>
        <input value={name} onChange={(e) => setName(e.target.value)} />
        <div style={{ height: '10px' }}>
          <p style={{ color: '#ff0000', fontSize: '.7rem', marginBottom: '0px', position: 'relative' }}>{error}</p>
        </div>
        <button type="submit" style={{ width: '150px', height: '40px', borderRadius: '10px', backgroundColor: '#32a852', marginTop: '15px' }}>Connect</button>
      </form>
    </div>
  )
}